import dataStudio from "../services/data.studio";
import auth from "./auth";

export default {
    namespaced: true,
    state: {
        dataStudioLink: null,
        loading: false,
        errors: null
    },
    mutations: {
        loading(state, value = true) {
            state.loading = value;
        },
        errors(state, errors) {
            state.errors = errors;
            state.loading = false;
        },
        setDataStudioLink(state, link) {
            state.dataStudioLink = link;
        }
    },
    actions: {
        async fetchDataStudioLink({ commit }) {
            commit("loading");
            try {
                const { data } = await dataStudio.fetchDataStudioLink(auth.state.user.merchant_uuid);
                
                commit("setDataStudioLink", data.data_studio_link);
                commit("loading", false);
            } catch (errors) {
                commit("loading", false);
            }
        }
    }
};
